import React from 'react';
import t from '@guestyci/localize/t.macro';
import { Button, Text, Stack } from '@guestyci/arc';
const EmailDisplay = ({ email, onChangeEmail, disabled }) => {
  return (
    <Stack direction="row" justify="between" align="center" className="gst-w-full">
      <Text size="base">
        {email || ''}
      </Text>
      <Button
        type="button"
        variant="plain-primary"
        size="sm"
        onClick={onChangeEmail}
        disabled={disabled}
      >
        {t('Change')}
      </Button>
    </Stack>
  );
};

export default EmailDisplay;
